export default {
  TS_AGREEMENT: 'TS_AGREEMENT',
  TS_AUCTION: 'TS_AUCTION',
  OTHER: 'OTHER',
};
